import React, { FC } from 'react';
import styled, { css, keyframes } from 'styled-components';

import { Size } from 'src/types';

interface SpinnerProps {
  /**
   * Big spinner is based on 74x74 pixels and border width is 6px
   * Medium spinner is based on 50x50 pixels and border width is 6px
   * Small spinner is based on 15x15 pixels and border width is 3px
   */
  size?: Size;
  /**
   * Inverted at this point means that component changes its base color to white
   */
  isInverted?: boolean;
  isCentered?: boolean;
  testId?: string;
  className?: string;
}

export const Spinner: FC<SpinnerProps> = ({
  size = 'medium',
  isInverted = false,
  isCentered = false,
  testId,
  className,
}) => (
  <SpinnerWrapper
    className={className}
    size={size}
    isInverted={isInverted}
    isCentered={isCentered}
    data-test-id={testId}
  />
);

const spinning = keyframes`
  from {
      transform: rotate(0);
    }
  to {
    transform: rotate(360deg);
  }
`;

const inverted = css`
  border-color: #fff;
  border-left-color: transparent;
`;

const centered = css`
  margin: auto;
`;

// TODO: Sizes definition should come through theme
const small = css`
  width: 1em;
  height: 1em;
  border-width: 0.125em;
`;

const medium = css`
  width: 3em;
  height: 3em;
  border-width: 0.25em;
`;

const large = css`
  width: 5em;
  height: 5em;
  border-width: 0.5em;
`;

const SpinnerWrapper = styled.div<SpinnerProps>`
  border-radius: 50%;
  border-style: solid;
  border-color: #157efb;
  border-left-color: transparent;
  transform-origin: center;
  animation: ${spinning} 800ms linear infinite;
  
  /* Theming Overrides */
  ${({ theme }) => theme?.overrides?.Spinner}

  ${({ isInverted }) => isInverted && inverted}
  ${({ isCentered }) => isCentered && centered}

  ${({ size }) =>
    (size === 'small' && small) ||
    (size === 'medium' && medium) ||
    (size === 'large' && large)}
  
`;
